/**
 * OrdersPage — `/orders`: every CIS order in the caller's scope, the track
 * beside Tharstern's Jobs (docs/features/order-to-invoice/
 * 08_order_pages_frontend_spec.md §5.1). Filtered by Route, Supplier, Status
 * and Health on the server.
 *
 * Staff only, behind the `orders` feature.
 */
import { Link } from "react-router";
import { paths } from "@shared-core/routing/routes";
import { OrdersList } from "../app/components/domain/orders/OrdersList";

export function OrdersPage() {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl">Orders</h1>
        <p className="text-sm text-muted-foreground">
          Orders One tracks from acceptance to invoice. Work made in-house in
          Tharstern stays under{" "}
          <Link to={paths.jobs()} className="underline">
            Jobs
          </Link>
          .
        </p>
      </div>
      <OrdersList />
    </div>
  );
}
